import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from "react-i18next";
import BlockUi from 'react-block-ui';
import { Button, Row, Col, Modal, Form, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SignalRService from "../../controllers/SignalRService";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import DataGrid, { Paging, Column, FilterRow } from 'devextreme-react/data-grid';

class Query extends Component {

    constructor(props) {
        super(props)
        this.state = {
            agents: [],
            loading: false,
            lastGroupsUpdate: new Date(0),
            showExternal: false,
            externalPhone: "",
            externalPhoneIsEmpty: false
        }

        this.setAgentsList = this.setAgentsList.bind(this);
        this.toggleExternal = this.toggleExternal.bind(this);
        this.cellRender = this.cellRender.bind(this);
        this.setExternalNumber = this.setExternalNumber.bind(this);
        this.keyDown = this.keyDown.bind(this);
        this.cellDispRender = this.cellDispRender.bind(this);

        SignalRService.registerAgentsListEvent(this.setAgentsList);

    }

    componentDidUpdate(prevProps, prevState) {
        let diff = Date.now() - this.state.lastGroupsUpdate;
        if (this.props.extension && this.props.userId && this.props.show && diff > 10000) {
            SignalRService.getAgents({
                "extension": this.props.extension,
                "userId": this.props.userId
            });
        }
    }

    setExternalNumber = (e) => {
        e.preventDefault();
        this.setState({
            externalPhone: e.target.value,
            externalPhoneIsEmpty: e.target.value === null || (e.target.value !== null && e.target.value.trim() === "")
        });
    }

    keyDown = (e) => {
        if (e.keyCode === 13) {
            this.externalConsultation(e);
        }
    }

    externalConsultation = (e) => {
        if (this.state.externalPhone !== null && this.state.externalPhone !== "") {
            this.consultation(this.state.externalPhone);
            this.setState({
                externalPhone: "",
                externalPhoneIsEmpty: false
            });
            this.toggleExternal(e);
        }
        else {
            this.setState({
                externalPhoneIsEmpty: true
            })
        }
    }

    setAgentsList = (agents) => {

        agents = agents.filter(x => x.extension !== this.props.extension && x.disponibility !== "LOGOUT");

        this.setState({
            agents: agents,
            lastGroupsUpdate: new Date()
        });

    }

    consultation = (called) => {
        SignalRService.consultation({
            "extension": this.props.extension,
            "userId": this.props.userId,
            "called": called
        });
        this.props.toggleModal();
        this.props.togglePhone();
    }

    toggleExternal = (e) => {
        this.setState({
            showExternal: !this.state.showExternal
        });
    }

    cellRender(cellData) {
        return (
            <span role={"button"} className={'text-primary'} onClick={
                () => { this.consultation(cellData.value) }
            }>{cellData.value}</span>
        );
    }


    cellDispRender(cellData) {
        
        var status = "";
        var icon = <></>;

        switch (cellData.value) {
            case "BUSY":
                status = this.props.t("busy");
                icon = <FontAwesomeIcon className="px-1 text-danger" size="lg" icon={duotone("phone")} />;
                break;
            case "AVAILABLE":
                status = this.props.t("available");
                icon = <FontAwesomeIcon className="px-1 text-success" size="lg" icon={duotone("check")} />;
                break;
            case "PAUSE":
                status = this.props.t("paused");
                icon = <FontAwesomeIcon className="px-1 text-danger" size="lg" icon={duotone("pause")} />;
                break;
            default:
                break;
        }

        return (
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>{status}</Tooltip>}>
                <div style={{ display: "inline-block" }}>
                    {icon}
                </div>
            </OverlayTrigger>

        );
    }

    cellClick = (e) => {

    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="md">
                <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon icon={duotone('square-question')} size="2x" /> {this.props.t("query")} </Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <div className="" key="-1">
                                    <div className='card-body py-8 pt-0'>
                                        <div className="position-relative ps-6 ">
                                            <div className={"position-absolute start-0 top-0 w-6px h-100 rounded-2 bg-primary"}></div>
                                            <Row>
                                                <Col>
                                                    <Button variant="light" onClick={this.toggleExternal}>   <span className={"fs-4 text-primary"}>{this.props.t("externalnumber")}</span></Button>
                                                </Col>
                                            </Row>
                                            {
                                                (this.state.showExternal) &&
                                                <>
                                                    <br />
                                                    <Row>
                                                        <Col>
                                                            <InputGroup className="mb-3">
                                                                <Form.Control
                                                                    placeholder={this.props.t("externalnumber")}
                                                                    aria-label={this.props.t("externalnumber")}
                                                                    aria-describedby="basic-addon2"
                                                                    isInvalid={this.state.externalPhoneIsEmpty}
                                                                    value={this.state.externalPhone}
                                                                    onChange={this.setExternalNumber}
                                                                    onKeyDown={this.keyDown}
                                                                    autoFocus
                                                                />
                                                                <Button onClick={this.externalConsultation}>
                                                                    <FontAwesomeIcon icon={faPhone} />
                                                                </Button>
                                                            </InputGroup>
                                                            {
                                                                (this.state.externalPhoneIsEmpty) &&
                                                                <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                                    {this.props.t("usernammeisempty")}
                                                                </Form.Text>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <DataGrid
                                    dataSource={this.state.agents}
                                    keyExpr="userId"
                                    showBorders={true}
                                    noDataText=""
                                    rowAlternationEnabled={true}>
                                    <Column dataField="shortName" caption={this.props.t("agent")} />
                                    <Column dataField="disponibility" caption={this.props.t("status")} cellRender={this.cellDispRender} alignment="center" width={80} />
                                    <Column dataField="extension" caption={this.props.t("extension")} cellRender={this.cellRender} />
                                    <FilterRow visible={true} applyFilter={"auto"} showOperationChooser={false} />
                                    <Paging defaultPageSize={5} />
                                </DataGrid>
                            </Col>
                        </Row>
                    </Modal.Body>
                </BlockUi>
            </Modal >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        phoneStatus: state.agent.phoneStatus,
        previousPhoneStatus: state.agent.previousPhoneStatus,
        functions: state.agent.functions
    };
};

export default compose(connect(mapStateToProps), withTranslation())(Query);
